exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toolbar{height:70px;position:fixed;z-index:100;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important}.menu-nav,.toolbar{background-color:#fff;width:100vw}.logo{margin-top:10px;height:55px;width:90%}", ""]);

// exports
